import { CoreBase, ICoreBase } from './CoreBase'


export class Cotacao extends CoreBase implements ICotacao {

}

export interface ICotacao extends ICoreBase {

}
